import { isCookiePresent, set3PCookie } from '../../../util/cookieHelper';
import { Cookies } from '../../../enums/network';
import { call } from 'redux-saga/effects';
import { mountLinearStepper } from '../../../components/linearStepper';
import { isCustomerIn3pFlowByUrl } from '../../../util/url';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { AppHtmlId } from '../../../enums/elementId';
import { getCMSConfig } from '../../../util/cms';
import { StepperData } from '../../../interfaces/additionalPageOptions';

const STEPPER_DATA = {
    stepper2P: {
        labels: {
            0: 'Verfügbarkeit',
            1: 'Router',
            2: 'Angaben',
            3: 'Prüfung',
        },
        activeStep: 1,
    },
    stepper3P: {
        labels: {
            0: 'Informieren',
            1: 'Internet-Paket wählen',
            3: 'TV im Warenkorb hinzufügen',
        },
        activeStep: 2,
    },
};

/**
 * Handles case when customer comes with the intention to buy 3P (Internet, Phone, TV)
 */
export function* handleStepper () {
    const is3PFlowByUrl: boolean = yield call(isCustomerIn3pFlowByUrl);
    const cookiePresent: boolean = yield call(isCookiePresent, Cookies.THREE_P);

    const { stepper2P, stepper3P }: StepperData = getCMSConfig() && getCMSConfig().stepperInfo || STEPPER_DATA;
    const threePStepLabels = Object.values(stepper3P.labels);
    const twoPStepLabels = Object.values(stepper2P.labels);

    if (cookiePresent) {
        yield call(mountLinearStepper, threePStepLabels, stepper3P.activeStep);
        yield call(toggleElementVisibilityById, AppHtmlId.LINEAR_STEPPER, true);

        return;
    }

    if (!is3PFlowByUrl) {
        yield call(mountLinearStepper, twoPStepLabels, stepper2P.activeStep);
        yield call(toggleElementVisibilityById, AppHtmlId.LINEAR_STEPPER, true);

        return;
    }

    yield call(set3PCookie);
    yield call(mountLinearStepper, threePStepLabels, stepper3P.activeStep);
    yield call(toggleElementVisibilityById, AppHtmlId.LINEAR_STEPPER, true);
}
